import { registerEphemeralRoute } from "./handle-ephemeral-routes";
import { EventContext } from "@/domains/metrics/context";

/**
 * Registers all ephemeral route handlers.
 * Should be called during module initialization, before React Router initializes.
 */
export const registerEphemeralRouteHandlers = (): void => {
  // Register /notes/new?title=... handler
  registerEphemeralRoute({
    path: "/notes/new",
    queryParam: "title",
    handler: async (title, { store }) => {
      await store.notes.composeNewNote({
        eventContext: EventContext.EphemeralRoute,
        title,
        autoFocusPosition: "end",
      });
    },
  });
};
